import { render, staticRenderFns } from "./LecturesRootView.vue?vue&type=template&id=a5718b44"
import script from "./LecturesRootView.vue?vue&type=script&lang=js"
export * from "./LecturesRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports